module.exports = __webpack_public_path__ + "img/vivo-wh.f7ca0224.svg";